<template>
  <div class="main-modal-panels">
    <template>
      <div>
        <div class="main-sidebar">
          <p class="create-card">{{ $t('panel.createCardPanel.editCard.title') }}</p>

          <label class="card-description">
            {{ $t('panel.createCardPanel.editCard.description') }}
          </label>

          <label class="label-text">{{ $t('panel.createCardPanel.editCard.titlePanel') }}</label>
          <input
            style="border-radius: 30px;"
            class="form-control"
            v-model="dataCard.title"
          />

          <label class="label-text">{{ $t('panel.createCardPanel.editCard.chooseMetric') }}</label>
          <b-form-select
            style="border-radius: 30px;"
            class="form-control"
            v-model="dataCard.metric"
            :options="optionsMetrics"
          ></b-form-select>

          <label class="label-text">{{ $t('panel.createCardPanel.editCard.chooseTypeAnalysis') }}</label>

          <b-dropdown
            style="border: 1px solid #ced4da; border-radius: 30px;"
            squared
            variant="outline-link"
            class="btn-block"
            menu-class="p-2"
            no-caret
          >
            <template slot="button-content">
              <span style="float: left; font-size: 1rem;">
                {{dataCard.typeAnalysis}}
              </span>
            </template>
            <b-dropdown-item
              href="#"
              v-for="(item, i) in optionsAnalysis"
              :key="i"
              @click="setAnalysysis(item)"
            >
              <span class="string--formater-drop" :title="item.text">
                {{ item.text }}
              </span>
            </b-dropdown-item>
          </b-dropdown>

          <label class="label-text">{{ $t('panel.createCardPanel.editCard.chooseReport') }}</label>
          <b-form-select
            class="form-control"
            v-model="dataCard.report"
            :options="optionsReports"
            style="border-radius: 30px;"
          ></b-form-select>

          <label class="label-text">{{ $t('panel.createCardPanel.editCard.choosePeriod') }}</label>
          <div style="display: flex;">
            <b-form-select
              class="form-control"
              v-model="selectedPeriod"
              :options="optionsPeriod"
              style="border-radius: 30px;"
            ></b-form-select>

            <div style="margin-top: 5px;">
              <vc-date-picker
                mode="range"
                :popover="{
                  placement: $screens({ default: 'bottom', md: 'left-start' }),
                }"
                v-model="dates"
                color="green"
              >
                <font-awesome-icon
                  :icon="['fas', 'calendar-alt']"
                  class="ml-2 calendar-icon"
                  style="font-size: 18px; margin-top: 5px;"
                />
              </vc-date-picker>
            </div>
          </div>

          <!--<template v-if="selectedPeriod === 'Personalizado'">
            <label
              >Período:
              {{ dates.start ? returnDates(dates) : periodData }}</label
            >
            <br />
          </template>
-->
          <label class="label-text">{{ $t('panel.createCardPanel.editCard.chooseFilter') }}</label>
          <b-form-select
            class="form-control"
            v-model="filterGroup"
            :options="optionsGroup"
            style="border-radius: 30px;"
          ></b-form-select>

          <template v-if="filterGroup === 'Grupo de ações'">
            <label class="label-text">{{ $t('panel.createCardPanel.editCard.chooseFilter') }}</label>

            <b-dropdown
              variant="outline-secondary"
              class="btn-block"
              menu-class="w-100 p-2"
              no-caret
            >
              <template slot="button-content">
                <span style="float: left;" class="button--formater2">
                  {{ groupAction ? groupAction.name : $t('panel.createCardPanel.filterOptions.actionGroupName') }}
                </span>
              </template>
              <input
                type="text"
                class="form-control mb-2"
                v-model="actionGroupFilter"
              />
              <b-dropdown-item
                href="#"
                v-for="(group, i) in allGroups"
                :key="i"
                @click="setActionGroup(group)"
              >
                <span class="string--formater" :title="group.name">
                  {{ group.name }}
                </span>
              </b-dropdown-item>
            </b-dropdown>
          </template>

          <template v-if="filterGroup === 'Ação'">
            <label class="label-text">{{ $t('panel.createCardPanel.editCard.chooseAction') }}</label>

            <b-dropdown
              variant="outline-secondary"
              class="btn-block panel"
              menu-class="w-100 p-2"
              no-caret
            >
              <template slot="button-content">
                <span style="float: left;" class="button--formater2">
                  {{ action ? action.name : $t('panel.createCardPanel.filterOptions.action') }}
                </span>
              </template>
              <input
                type="text"
                class="form-control mb-2"
                v-model="actionFilter"
              />
              <b-dropdown-item
                href="#"
                v-for="(item, i) in actions"
                :key="i"
                @click="setValAction(item)"
              >
                <span class="string--formater" :title="item.name">
                  {{ item.name }}
                </span>
              </b-dropdown-item>
            </b-dropdown>
          </template>

          <template v-if="filterGroup === 'Filial'">
            <label class="label-text">{{ $t('panel.createCardPanel.editCard.chooseBranch') }}</label>

            <b-dropdown
              variant="outline-secondary"
              class="btn-block"
              menu-class="w-100 p-2"
              no-caret
            >
              <template slot="button-content">
                <span class="button--formater">
                  {{ dataCard.ih1.length > 0 ? `${returnIh1Names(dataCard.ih1[0])} ${dataCard.ih1.length > 1 ? `+ ${dataCard.ih1.length - 1}` : ''}` : $t('panel.createCardPanel.filterOptions.filial') }}
                
                </span>
              </template>
              <input
                type="text"
                class="form-control mb-2"
                v-model="branchFilter"
              />
              <b-dropdown-item
                href="#"
                v-for="(item, i) in allBranches"
                :key="i"
                @click="setValBranch(item)"
              >
                <span class="string--formater" :title="item">
                  {{ item.corporate_name }}
                </span>
              </b-dropdown-item>
            </b-dropdown>
          </template>

          <template v-if="filterGroup === 'Indicador'">
            <label class="label-text">{{ $t('panel.createCardPanel.editCard.chooseIndicator') }}</label>

            <b-dropdown
              squared
              variant="outline-secondary"
              class="btn-block"
              menu-class="w-100 p-2"
              no-caret
            >
              <template slot="button-content">
                <span class="button--formater2">
                  {{ indicator ? indicator.text : $t('panel.createCardPanel.filterOptions.indicator') }}
                </span>
              </template>
              <input
                type="text"
                class="form-control mb-2"
                v-model="indicatorFilter"
                @keypress.enter="setIndicator(indicator)"
              />
              <b-dropdown-item
                href="#"
                v-for="(indicator, i) in getIndicatorsPaginate()"
                :key="i"
                @click="setIndicator(indicator)"
              >
                <span class="string--formater" :title="indicator.text">
                  <div class="list">
                    <div class="list-element">{{ indicator.text }}</div>
                  </div>
                </span>
              </b-dropdown-item>
              <button id="loadmore" class="btn-loadmore" @click="loadMore">
                {{ $t('panel.createCardPanel.editCard.showMore') }}>>
              </button>
            </b-dropdown>

            <template v-if="indicator">
              <label class="label-text">{{ $t('panel.createCardPanel.editCard.chooseValueIndicator') }}</label>

              <div v-if="!isDateIndicator(indicator)">
                <b-dropdown
                  variant="outline-secondary"
                  class="btn-block"
                  menu-class="w-100"
                  no-caret
                >
                  <template slot="button-content">
                    <span class="button--formater2">
                      {{
                        valueIndicator
                          ? valueIndicator.text
                          : 'Selecione um valor'
                      }}
                    </span>
                  </template>
                  <input
                    type="text"
                    class="form-control mb-2"
                    v-model="indicatorValueFilter"
                  />
                  <b-dropdown-item
                    href="#"
                    v-for="(item, i) in getIndicatorsValuePaginate()"
                    :key="i"
                    @click="handleIndicatorData(item)"
                  >
                    <span class="string--formater" :title="item.text">
                      {{ item.text }}
                    </span>
                  </b-dropdown-item>
                  <button
                    id="loadmore-indic-value"
                    class="btn-loadmore"
                    @click="loadMoreIndicValue"
                  >
                    {{ $t('panel.createCardPanel.editCard.showMore') }}>>
                  </button>
                </b-dropdown>
              </div>
            </template>
          </template>

          <div v-if="dataCard.indicator && dataCard.valueIndicator">
            <template v-if="arrayIndicators.length > 0">
                <div
                    v-for="(item, index) in arrayIndicators"
                    :key="index"
                    class="tags-array"
                  >
                    <span>
                      {{ item.key }}:
                      {{ item.value }}
                    </span>
                    <span @click="removeFilterIndicator(index)" class="remove"
                      >&times;</span
                    >
                </div>
            </template>
          </div>

          <div v-if="dataCard.ih1.length > 0">
           <div class="tag" v-for="(item, ih1Index) in dataCard.ih1" :key="ih1Index">
              <span>
                Filial:
                {{ returnIh1Names(item) }}
              </span>
              <span @click="removeFilter('branch', ih1Index)" class="remove">&times;</span>
           </div>
          </div>

          <div v-if="dataCard.actionId" class="tag">
            <span>
              Ação:
              {{ dataCard.actionId.name }}
            </span>
            <span @click="removeFilter('action')" class="remove">&times;</span>
          </div>

          <div v-if="dataCard.actionGroupId" class="tag">
            <span>
              Grupo de ação:
              {{ dataCard.actionGroupId.name }}
            </span>
            <span @click="removeFilter('groupAction')" class="remove"
              >&times;</span
            >
          </div>

          <label class="label-text"
            >{{ $t('panel.createCardPanel.editCard.chooseTypeGraph') }}
          </label>

          <template>
            <div style="display: flex; margin-top: 10px;">
              <button
                @click="onSlideEnd"
                style="
                  font-size: 30px;
                  background: #fff;
                  border: none;
                  outline: 0;
                  color: #5e5e5e;
                "
              >
                <font-awesome-icon :icon="['fas', 'angle-left']" />
              </button>

              <b-carousel
                id="carousel-1"
                v-model="slide"
                background="#fff"
                :interval="0"
                style="text-shadow: 1px 1px 2px #333; border: 2px dotted #333;"
              >
                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Análise por dispositivo'"
                  :img-src="analyzeDevice"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Evolução de sentimento'"
                  :img-src="evolutionSentimentArea"
                >
                </b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Evolução de sentimento'"
                  :img-src="evolutionSentimentBar"
                >
                </b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Evolução de sentimento'"
                  :img-src="evolutionSentimentLine"
                >
                </b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Classificação de sentimento'"
                  :img-src="sentimentGraph"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Classificação de sentimento'"
                  :img-src="sentiment"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Análise de sentimento'"
                  :img-src="analyzeSentiment5"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Categorias'"
                  :img-src="categories"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Comparativo de ação'"
                  :img-src="comparativeActions"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Evolução de ações'"
                  :img-src="evolutionActions"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Evolução de convites'"
                  :img-src="evolutionInvitesArea"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Evolução de convites'"
                  :img-src="evolutionInvitesBar"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Evolução de convites'"
                  :img-src="evolutionInvitesLine"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="
                    dataCard.report === 'Evolução de nps' ||
                    dataCard.report === 'Evolução de ces' ||
                    dataCard.report === 'Evolução de csat' ||
                    dataCard.report === 'Evolução de Five Stars'
                  "
                  :img-src="evolutionNps"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="
                    dataCard.report === 'Evolução de nps' ||
                    dataCard.report === 'Evolução de ces' ||
                    dataCard.report === 'Evolução de csat' ||
                    dataCard.report === 'Evolução de Five Stars'
                  "
                  :img-src="evolutionNpsArea"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="
                    dataCard.report === 'Evolução de nps' ||
                    dataCard.report === 'Evolução de ces' ||
                    dataCard.report === 'Evolução de csat' ||
                    dataCard.report === 'Evolução de Five Stars'
                  "
                  :img-src="evolutionNpsLine"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Evolução de percentuais'"
                  :img-src="evolutionNpsLine"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Nuvem de palavras'"
                  :img-src="cloudWord"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Score de sentimento'"
                  :img-src="scoreSentiment"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Indicador de sentimento'"
                  :img-src="indicatorSentiment"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Top 5 keywords'"
                  :img-src="topKeywords"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Conversão'"
                  :img-src="conversion"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Ranking like/dislike'"
                  :img-src="likeDislike"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Ranking multipla escolha'"
                  :img-src="multiple"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Ranking likert'"
                  :img-src="likert"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Relatório de mapa'"
                  :img-src="map"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Ranking nps'"
                  :img-src="nps"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Ranking Ces 1 a 5'"
                  :img-src="ces"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Ranking emotion'"
                  :img-src="emotion"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Ranking escala 0 a 10'"
                  :img-src="csat"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Ranking review'"
                  :img-src="review"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Detratores recorrentes'"
                  :img-src="recurringDetractor"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Resposta por canais'"
                  :img-src="questionByChannel"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Status de tratativas'"
                  :img-src="statusTreatments"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Tags de tratativas'"
                  :img-src="tagsTreatments"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Monitoramento de pesquisa'"
                  :img-src="surveyInvites"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Análise de indicador'"
                  :img-src="indicadorAnalyze"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Evolução de respostas'"
                  :img-src="evolutionAnswerArea"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Evolução de respostas'"
                  :img-src="evolutionAnswerBar"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Evolução de respostas'"
                  :img-src="evolutionAnswerLine"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Evolução like/dislike'"
                  :img-src="evolutionLikeDislikeArea"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Evolução like/dislike'"
                  :img-src="evolutionLikeDislikeBar"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Evolução like/dislike'"
                  :img-src="evolutionLikeDislikeLine"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Indice Nps' ||
                    dataCard.report === 'Indice Ces' ||
                    dataCard.report === 'Indice Csat' ||
                    dataCard.report === 'Indice Like/Dislike' ||
                    dataCard.report === 'Indice Five Stars'"
                  :img-src="index"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Nps-Percentual' ||
                     dataCard.report === 'Ces-Percentual' ||
                     dataCard.report === 'Csat-Percentual' ||
                     dataCard.report === 'Like/Dislike-Percentual' ||
                     dataCard.report === 'Five Stars-Percentual'"
                  :img-src="percentage"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="dataCard.report === 'Distribuição de notas'"
                  :img-src="gradeDistribution"
                ></b-carousel-slide>
              </b-carousel>

              <button
                @click="onSlideStart"
                style="
                  font-size: 30px;
                  background: #fff;
                  border: none;
                  color: #5e5e5e;
                  outline: 0;
                "
              >
                <font-awesome-icon :icon="['fas', 'angle-right']" />
              </button>
            </div>
          </template>

          <center>
            <p>{{ $t('panel.createCardPanel.editCard.graphics') }} {{ slide + 1 }}</p>
          </center>

          <template footer>
            <div class="pb-4" style="padding-left: 55%;">
              <div>
                <b-button variant="outline-primary" @click="cancel"
                  >{{ $t('panel.createCardPanel.editCard.cancel') }}</b-button
                >
                <b-button variant="primary" @click="saveCard">{{ $t('panel.createCardPanel.editCard.save') }}</b-button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { lightFormat } from 'date-fns';
import imgUseTemplate from '../../../assets/use-template.jpg';
import imgMakePanel from '../../../assets/make-panel.jpg';
import analyzeDevice from '../../../assets/analise-dispositivo.png';
import analyzeSentiment1 from '../../../assets/analise-sentimento-1.png';
import analyzeSentiment3 from '../../../assets/analise-sentimento-3.png';
import analyzeSentiment4 from '../../../assets/analise-sentimento-4.png';
import analyzeSentiment5 from '../../../assets/analise-sentimento-5.png';
import sentimentGraph from '../../../assets/classificacao-sentimento-grafico.png';
import evolutionSentimentArea from '../../../assets/evolucao-sentimento-area.png';
import evolutionSentimentBar from '../../../assets/evolucao-sentimento-barras.png';
import evolutionSentimentLine from '../../../assets/evolucao-sentimento-linhas.png';
import indicatorSentiment from '../../../assets/indicador-sentimento.png';
import topKeywords from '../../../assets/top5-keywords.png';
import conversion from '../../../assets/conversao.png';
import statusTreatments from '../../../assets/status-tratativas.png';
import sentiment from '../../../assets/classificacao-sentimento.png';
import categories from '../../../assets/categorias.png';
import scoreSentiment from '../../../assets/score-sentimento.png';
import comparativeActions from '../../../assets/comparativo-ações.png';
import evolutionActions from '../../../assets/evolução-ações.png';
import evolutionInvites from '../../../assets/evolução-convites.png';
import evolutionNps from '../../../assets/evolução-nps.png';
import evolutionNpsArea from '../../../assets/evolução-nps-area.png';
import evolutionNpsLine from '../../../assets/evolução-nps-linha.png';
import evolutionPercentage from '../../../assets/evolução-percentuais.png';
import cloudWord from '../../../assets/nuvem-palavras.png';
import addQuestion from '../../../assets/pergunta-adicional.png';
import questionByChannel from '../../../assets/pergunta-canais.png';
import ranking from '../../../assets/ranking-pergunta-adicional.png';
import recurringDetractor from '../../../assets/detratores-recorrentes.png';
import likeDislike from '../../../assets/like-dislike-panel.png';
import csat from '../../../assets/escala0a10-csat.png';
import review from '../../../assets/review.png';
import emotion from '../../../assets/emotion.png';
import ces from '../../../assets/addquestion-ces.png';
import likert from '../../../assets/addquestion-likert.png';
import tagsTreatments from '../../../assets/tags-tratativas.png';
import nps from '../../../assets/addquestion-nps.png';
import map from '../../../assets/relatorio-mapa.png';
import multiple from '../../../assets/multipla-escolha.png';
import indicadorAnalyze from '../../../assets/analise-indicador.png';
import surveyInvites from '../../../assets/monitoramento-pesquisa.png';
import evolutionInvitesBar from '../../../assets/evolucao-convites-bar.png';
import evolutionInvitesArea from '../../../assets/evolucao-convites-area.png';
import evolutionInvitesLine from '../../../assets/evolucao-convites-line.png';
import evolutionAnswerBar from '../../../assets/evolucao-respostas-barra.png';
import evolutionAnswerArea from '../../../assets/evolucao-respostas-area.png';
import evolutionAnswerLine from '../../../assets/evolucao-respostas-linha.png';
import evolutionLikeDislikeBar from '../../../assets/evolucao-like-dislike-barra.png';
import evolutionLikeDislikeArea from '../../../assets/evolucao-like-dislike-area.png';
import evolutionLikeDislikeLine from '../../../assets/evolucao-like-dislike-linha.png';
import index from '../../../assets/indice.png';
import percentage from '../../../assets/percentual.png';
import gradeDistribution from '../../../assets/distribuicao-notas.png';
import EventBus from '../../../eventBus';
import api from '../../../services/api';

import modalAddTemplateDefault from '../modal-add-template';

export default {
  name: 'ModalAddPanels',

  props: {
    hide: {
      type: String,
      required: false,
      default: '',
    },
    dataCard: {
      type: Object,
      required: false,
    },
  },

  components: {
    modalAddTemplateDefault,
  },

  computed: {
    ...mapState('panels', ['panelsInfo', 'showSidebar', 'idPanel', 'panel']),
    ...mapFields('panels', ['loading']),
    ...mapFields('profiles', ['profiles']),
    ...mapFields('actions', ['allGroups']),
    ...mapState('branches', ['ih1', 'ih2']),
  },

  data: () => ({
    disabledCustom: true,
    disabledDefault: true,
    modalPanel: null,
    // showSidebar: null,
    imgUseTemplate,
    imgMakePanel,
    optionsReports: [],
    optionsAnalysis: [],
    selectedReport: null,
    selectedAnalysis: null,
    selectedPeriod: null,
    slide: 0,
    sliding: null,
    title: '',
    description: '',
    perfils: [],
    userAuth: null,
    allAnalysesTypes: null,
    filterGroup: null,
    optionsGroup: [],
    groupAction: null,
    action: null,
    branch: null,
    indicators: null,
    valuesIndicator: [],
    indicator: null,
    valueIndicator: null,
    metric: null,
    optionsMetrics: [
      {
        value: null,
        text: 'Selecione a métrica',
      },
      {
        value: 'nps-0-10',
        text: 'NPS - escala 0 a 10',
      },
      {
        value: 'nps-1-5',
        text: 'NPS - escala 1 a 5',
      },
      {
        value: 'ces-1-5',
        text: 'CES - escala 1 a 5',
      },
      {
        value: 'csat-1-5',
        text: 'CSAT - escala 1 a 5(Top 2 box)',
      },
      {
        value: 'csat-1-5(media)',
        text: 'CSAT - escala 1 a 5(media)',
      },
      {
        value: '5-stars',
        text: '5-Stars',
      },
      {
        value: 'like-dislike',
        text: 'Like/Dislike 0 e 1',
      },
    ],
    optionsPeriod: [],
    limit: 20,
    limitValue: 20,
    indicatorsFilterValue: [],
    actionFilter: null,
    indicatorFilter: null,
    actionGroupFilter: null,
    branchFilter: null,
    indicatorValueFilter: null,
    graph: null,
    periodData: '',
    dates: {
      start: null,
      end: +new Date(),
      selected: 'Personalizado',
    },
    dateStartEnd: null,
    period: null,
    analyzeDevice,
    analyzeSentiment1,
    analyzeSentiment3,
    analyzeSentiment4,
    analyzeSentiment5,
    evolutionSentimentArea,
    evolutionSentimentBar,
    evolutionSentimentLine,
    indicatorSentiment,
    sentimentGraph,
    statusTreatments,
    tagsTreatments,
    topKeywords,
    sentiment,
    conversion,
    categories,
    comparativeActions,
    evolutionActions,
    evolutionInvites,
    evolutionNps,
    evolutionPercentage,
    cloudWord,
    addQuestion,
    questionByChannel,
    ranking,
    scoreSentiment,
    review,
    csat,
    likeDislike,
    emotion,
    ces,
    likert,
    nps,
    multiple,
    indicadorAnalyze,
    map,
    evolutionAnswerBar,
    evolutionAnswerArea,
    evolutionAnswerLine,
    surveyInvites,
    evolutionNpsArea,
    evolutionNpsLine,
    evolutionInvitesBar,
    evolutionInvitesArea,
    evolutionInvitesLine,
    evolutionLikeDislikeBar,
    evolutionLikeDislikeArea,
    evolutionLikeDislikeLine,
    allIndicators: null,
    recurringDetractor,
    allActionGroup: null,
    allActionData: null,
    actions: null,
    allBranches: null,
    allActions: null,
    index,
    percentage,
    gradeDistribution,
    arrayIndicators: [],
    blockLoop: false,
    previousDiffIndicator: false,
    splits: [],
    limitIndicatorValue: 20,
  }),

  methods: {
    ...mapActions('profiles', ['getProfiles']),
    ...mapActions('panels', ['setPanelsInfo', 'setShowEditPanel']),

    returnIh1Names(idIh1){
      for (let i = 0; i < this.ih1.listFilters.length; i+=1){
          if (this.ih1.listFilters[i]._id === idIh1){
            return this.ih1.listFilters[i].corporate_name;
          }
      }

      return "-";
    },

    returnTypeAnalysis(dataCard){
      if(this.$i18n.locale === 'br'){
        if(dataCard.typeAnalysis){
          this.dataCard.typeAnalysis =  dataCard.typeAnalysis;
        }else{
          this.dataCard.typeAnalysis = "Selecione uma analise";
        }
      }else if(this.$i18n.locale === 'us'){
        if(dataCard.typeAnalysis){
          this.dataCard.typeAnalysis =  dataCard.typeAnalysisEn;
        }else{
          this.dataCard.typeAnalysis = "Select an analyse";
        }
      }else if(this.$i18n.locale === 'es'){
        if(dataCard.typeAnalysis){
          this.dataCard.typeAnalysis =  dataCard.typeAnalysisEs;
        }else{
          this.dataCard.typeAnalysis = "Seleccione un análisis";
        }
      }
    },

    removeFilterIndicator(i){
      this.arrayIndicators.splice(i, 1);
    },

    returnPeriod(period) {
      let periodValue;

      if (
        period !== 'Ultimos 30 dias' &&
        period !== 'Hoje' &&
        period !== 'Ontem' &&
        period !== 'Mes atual' &&
        period !== 'Mes anterior' &&
        period !== 'Ano atual' &&
        period &&
        'Ano anterior'
      ) {
        periodValue = 'Personalizado';
      } else {
        periodValue = period;
      }

      return periodValue;
    },

    returnData(period) {
      if (this.optionsPeriod.includes(period)) {
        return true;
      }

      return true;
    },

    returnDates(dates) {
      if (dates) {
        const start = lightFormat(new Date(dates.start), 'dd/MM/yyyy');
        const end = lightFormat(new Date(dates.end), 'dd/MM/yyyy');

       return `${start} a ${end}`;
      }

      return `${dates}`;
    },

    async cancel() {
      await this.setShowEditPanel(false);
    },

    removeFilter(value, index) {
      if (value === 'indicator') {
        this.dataCard.valueIndicator = null;
        this.dataCard.indicator = null;
      } else if (value === 'branch') {
        this.dataCard.ih1.splice(index, 1);
      } else if (value === 'action') {
        this.dataCard.actionId = null;
      } else if (value === 'groupAction') {
        this.dataCard.actionGroupId = null;
      }
    },

    handleIndicatorData(item) {
      this.dataCard.valueIndicator = item;

      this.arrayIndicators.push({
        key: this.indicator.text,
        value: item.text
      })
    },

    loadMoreIndicValue() {
      this.limitIndicatorValue = this.limitIndicatorValue + 20;
    },

    getIndicatorsValuePaginate() {
      let indicators;

      if (this.indicatorsFilterValue) {
        // if (this.limitValue >= this.indicatorsFilterValue.length) {
        //   document.querySelector('#loadmore-indic-value').style.display =
        //     'none';
        // } else {
        //   document.querySelector('#loadmore-indic-value').style.display =
        //     'block';
        // }

        indicators = this.indicatorsFilterValue.slice(0, this.limitIndicatorValue);

        // if (indicators.length < 19) {
        //   document.querySelector('#loadmore-indic-value').style.display =
        //     'none';
        // }
      }
      return indicators;
    },

    checkIndicatorData() {
      if (this.indicator) {
        return this.$t('menu.filter.indicators', {
          indicatorData: `${this.indicator.name}`,
        });
      }
      return this.$t('menu.filter.indicatorData');
    },

    isDateIndicator(value) {
      if (this.indicators) {
        for (let i = 0; i < this.indicators.length; i += 1) {
          if (this.indicators[i]._id === value) {
            return true;
          }
        }
      }
      return false;
    },

    async setIndicator(indicator) {
      this.indicator = indicator;
      const indicatorBefore = this.dataCard.indicator;

      this.dataCard.indicator = indicator.key;

      if(this.dataCard.indicator !== indicatorBefore){
        this.arrayIndicators = [];
        this.valueIndicator = null;
        this.dataCard.valueIndicator = null;
        this.previousDiffIndicator = true;
      }

      const response = await api.get(
        `/filters/indicator-data/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            indicatorValue: indicator.key,
            groupId: null,
            actionId: null,
            ih1: null,
          },
        },
      );
      this.allIndicatorData = response.data;
      this.indicatorsFilterValue = response.data;
    },

    loadMore() {
      this.limit = this.limit + 20;
    },

    getIndicatorsPaginate() {
      let indicators;

      if (this.indicators) {
        if (this.limit >= this.indicators.length) {
          document.querySelector('#loadmore').style.display = 'none';
        } else {
          document.querySelector('#loadmore').style.display = 'block';
        }

        indicators = this.indicators.slice(0, this.limit);

        if (indicators.length < 19) {
          document.querySelector('#loadmore').style.display = 'none';
        }
      }
      return indicators;
    },

    setValBranch(branch) {
      if (!this.dataCard.ih1.includes(branch._id)) {
        this.dataCard.ih1.push(branch._id);
      }
    },

    setValAction(action) {
      this.action = action;
    },

    setActionGroup(group) {
      this.groupAction = group;
    },

    setAnalysysis(value) {
      this.dataCard.typeAnalysis = value.text;
    },

    onSlideStart() {
      if (this.slide !== this.slide.length - 1) {
        this.slide = this.slide + 1;
      }
    },
    onSlideEnd() {
      if (this.slide !== 0) {
        this.slide = this.slide - 1;
      }
    },

    async saveCard() {
      await this.setShowEditPanel(false);

      if (
        this.dataCard.report === 'Evolução de nps' ||
        this.dataCard.report === 'Evolução de ces' ||
        this.dataCard.report === 'Evolução de csat' ||
        this.dataCard.report === 'Evolução de Five Stars'
      ) {
        if (this.slide === 0) {
          this.dataCard.graph = 'column';
        } else if (this.slide === 1) {
          this.dataCard.graph = 'area';
        } else {
          this.dataCard.graph = 'line';
        }
      } else if (this.dataCard.report === 'Classificação de sentimento') {
        if (this.slide === 0) {
          this.dataCard.graph = 'graph';
        } else if (this.slide === 1) {
          this.dataCard.graph = 'card';
        }
      } else if (this.dataCard.report === 'Evolução de sentimento') {
        if (this.slide === 0) {
          this.dataCard.graph = 'area';
        } else if (this.slide === 1) {
          this.dataCard.graph = 'column';
        } else if (this.slide === 2) {
          this.dataCard.graph = 'line';
        }
      } else if (this.dataCard.report === 'Evolução de convites') {
        if (this.slide === 0) {
          this.dataCard.graph = 'area';
        } else if (this.slide === 1) {
          this.dataCard.graph = 'column';
        } else if (this.slide === 2) {
          this.dataCard.graph = 'line';
        }
      } else if (this.dataCard.report === 'Evolução de respostas') {
        if (this.slide === 0) {
          this.dataCard.graph = 'area';
        } else if (this.slide === 1) {
          this.dataCard.graph = 'column';
        } else if (this.slide === 2) {
          this.dataCard.graph = 'line';
        }
      } else if (this.dataCard.report === 'Evolução like/dislike') {
        if (this.slide === 0) {
          this.dataCard.graph = 'area';
        } else if (this.slide === 1) {
          this.dataCard.graph = 'column';
        } else if (this.slide === 2) {
          this.dataCard.graph = 'line';
        }
      } else {
        this.dataCard.graph = 'default';
      }

      if (this.selectedPeriod === 'Personalizado') {
        this.dataCard.period = this.returnDates(this.dates);
      } else {
        this.dataCard.period = this.selectedPeriod;
      }

      if(this.arrayIndicators.length > 0){
        this.dataCard.valueIndicator = '';
        for(let k=0; k < this.arrayIndicators.length; k+=1){
          if(k > 0){
            this.dataCard.valueIndicator += `,${this.arrayIndicators[k].value}`;
          }else{
             this.dataCard.valueIndicator += `${this.arrayIndicators[k].value}`;
          }
        }
      }else{
        this.dataCard.valueIndicator = null;
        this.dataCard.indicator = null;
      }

      await api.put(
        `/update/card`,
        {
          id: this.idPanel,
          dataCard: this.dataCard,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );

      EventBus.$emit('update-cards');

      this.getDataPanel();
    },

    async getDataPanel() {
      if (this.idPanel) {
        this.loading = true;
        const response = await api.get(`/get/panel/${this.idPanel}`, {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            idPanel: this.idPanel,
          },
        });

        this.panel.panelInfo = response.data.panelInfo;
        this.loading = false;
      }
    },

    openCreateCard() {
      this.$bvModal.hide('modal-create-panel');
    },

    openModalCreatePanel() {
      this.$bvModal.hide('modal-switch-option');
    },

    selectDefault() {
      this.disabledCustom = true;
      this.disabledDefault = false;

      document.getElementById('card-custom').style.background = '#f8f9fa';
      document.getElementById('card-default').style.background = '#fff';
    },

    selectCustomPainel() {
      this.disabledCustom = false;
      this.disabledDefault = true;

      document.getElementById('card-custom').style.background = '#fff';
      document.getElementById('card-default').style.background = '#f8f9fa';
    },

    async getTypeAnalysis() {
      const response = await api.get('get/analysis', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      this.allAnalysesTypes = response.data;
    },

    async handleIndicator() {
      const response = await api.get(
        `/filters/indicators/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
        },
      );

      this.indicators = response.data.indicators;
      this.allIndicators = response.data.indicators;
    },
  },

  watch: {
    branchFilter: function watchBranchFilterih1(value) {
      if (value) {
        this.allBranches = this.ih1.listFilters.filter((name) => {
          return name.corporate_name
            .toLowerCase()
            .includes(value.toLowerCase());
        });
      } else {
        this.allBranches = this.ih1.listFilters;
      }
    },
    actionFilter: function watchActionFilter(value) {
      if (value) {
        this.actions = this.actions.filter((action) => {
          return action.name.toLowerCase().includes(value.toLowerCase());
        });
      } else {
        this.actions = this.allActionData.data;
      }
    },
    actionGroupFilter: function watchActionGroupFilter(value) {
      if (value) {
        this.allGroups = this.allGroups.filter((group) => {
          return group.name.toLowerCase().includes(value.toLowerCase());
        });
      } else {
        this.allGroups = this.allActionGroup;
      }
    },
    indicatorFilter: function watchIndicatorFilter(value) {
      if (value) {
        this.indicators = this.indicators.filter((indicator) => {
          return indicator.key.toLowerCase().includes(value.toLowerCase());
        });
      } else {
        this.indicators = this.allIndicators;
      }
    },

    indicatorValueFilter: function watchIndicatorValue(value) {
      if (value) {
        this.indicatorsFilterValue = this.indicatorsFilterValue.filter(
          (indicator) => {
            return indicator.key.toLowerCase().includes(value.toLowerCase());
          },
        );
      } else {
        this.indicatorsFilterValue = this.allIndicatorData;
      }
    },

    dataCard: async function watchDataCard(data) {
      const response = await api.get('get/analysis', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      this.allAnalysesTypes = response.data;

      this.optionsAnalysis = [];
      this.optionsReports = [];
      const array = [];

      for (let i = 0; i < this.allAnalysesTypes.length; i += 1) {
        this.optionsReports = this.allAnalysesTypes[i].reports
      }

      for (let i = 0; i < this.allAnalysesTypes.length; i += 1) {
        if (data.metric === 'nps-0-10' || data.metric === 'nps-1-5') {
          if (this.allAnalysesTypes[i].metric.indexOf('nps') !== -1) {
            array.push(this.allAnalysesTypes[i]);
          }
        } else if (
          data.metric === 'csat-1-5' ||
          data.metric === 'csat-1-5(media)'
        ) {
          if (this.allAnalysesTypes[i].metric.indexOf('csat') !== -1) {
            array.push(this.allAnalysesTypes[i]);
          }
        } else if (
          this.allAnalysesTypes[i].metric.indexOf(data.metric) !== -1
        ) {
          array.push(this.allAnalysesTypes[i]);
        }

        if (
          this.allAnalysesTypes[i].analysisType === 'Categorias' ||
          this.allAnalysesTypes[i].analysisType === 'Analise de sentimento' ||
          this.allAnalysesTypes[i].analysisType === 'Perguntas adicionais' ||
         // this.allAnalysesTypes[i].analysisType === 'Indicadores' ||
          this.allAnalysesTypes[i].analysisType === 'Outros'
        ) {
          array.push(this.allAnalysesTypes[i]);
        }
      }

      array.forEach((el) => {
        el.reports.forEach((reports, indexDetractor) => {
          if(reports.text === 'Detratores recorrentes'){
            el.reports.splice(indexDetractor, 1);
          }
        });

        this.optionsAnalysis.push({
          value: el.analysisType,
          text: this.$i18n.locale === 'br' ? el.analysisType : this.$i18n.locale === 'es' ? el.analysisTypeEs : el.analysisTypeEn,
        });
      });

      if (data) {
        this.selectedPeriod = this.returnPeriod(data.period);
        if (this.selectedPeriod === 'Personalizado') {
          this.periodData = data.period;
        }
      }
    },

    dates: function watchDates(dates) {
      if(dates){
        const start = lightFormat(new Date(dates.start), 'dd/MM/yyyy');
      const end = lightFormat(new Date(dates.end), 'dd/MM/yyyy');

      this.selectedPeriod = 'Personalizado';

      this.dateStartEnd = `${start} a ${end}`;

      this.period = this.dateStartEnd;
      }
    },

    selectedPeriod: function watchSelectedPeriod(period) {
      this.dateStartEnd = null;

      if (period !== 'Personalizado') {
        this.period = period;
      }
    },

    action: function watchAction(value) {
      this.dataCard.actionId = { name: value.name, _id: value._id };
    },

    branch: function watchBranch(value) {
      this.dataCard.ih1.push({
        corporate_name: value.corporate_name,
        _id: value._id,
      });
    },

    groupAction: function watchActionGroup(value) {
      this.dataCard.actionGroupId = {
        name: value.name,
        _id: value._id,
      };
    },

    'dataCard.metric': async function watchMetric(metric) {
      this.getTypeAnalysis();

      this.allActionData = await api.get(
        `/filters/actions/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            type: metric,
          },
        },
      );

      this.actions = this.allActionData.data;
      this.allActions = this.allActionData.data;

      const array = [];

      this.optionsAnalysis = [];
      this.optionsReports = [];


      if (this.allAnalysesTypes && this.allAnalysesTypes.length > 0) {

        for (let i = 0; i < this.allAnalysesTypes.length; i += 1) {
          if (
            this.dataCard.typeAnalysis === this.allAnalysesTypes[i].analysisType ||
            this.dataCard.typeAnalysis === this.allAnalysesTypes[i].analysisTypeEn ||
            this.dataCard.typeAnalysis === this.allAnalysesTypes[i].analysisTypeEs
          ) {
            this.optionsReports = this.allAnalysesTypes[i].reports;
          }
        }

        for (let i = 0; i < this.allAnalysesTypes.length; i += 1) {
          if (metric === 'nps-0-10' || metric === 'nps-1-5') {
            if (this.allAnalysesTypes[i].metric.indexOf('nps') !== -1) {
              array.push(this.allAnalysesTypes[i]);
            }
          } else if (metric === 'csat-1-5' || metric === 'csat-1-5(media)') {
            if (this.allAnalysesTypes[i].metric.indexOf('csat') !== -1) {
              array.push(this.allAnalysesTypes[i]);
            }
          } else if (metric === 'like-dislike') {
            if (this.allAnalysesTypes[i].metric === 'like-dislike') {
              array.push(this.allAnalysesTypes[i]);
            }
          } else if (this.allAnalysesTypes[i].metric.indexOf(metric) !== -1) {
            array.push(this.allAnalysesTypes[i]);
          }

          if (
            this.allAnalysesTypes[i].analysisType === 'Categorias' ||
            this.allAnalysesTypes[i].analysisType === 'Analise de sentimento' ||
            this.allAnalysesTypes[i].analysisType === 'Perguntas adicionais' ||
           // this.allAnalysesTypes[i].analysisType === 'Indicadores' ||
            this.allAnalysesTypes[i].analysisType === 'Outros'
          ) {
            array.push(this.allAnalysesTypes[i]);
          }
        }

        array.forEach((el) => {
          el.reports.forEach((reports, indexReport) => {
            if(reports.text === 'Detratores recorrentes' ||
             // reports.text === 'Evolução de convites' ||
              reports.text === 'Indicador de sentimento'){
                el.reports.splice(indexReport, 1);
            }
          });

          this.optionsAnalysis.push({
            value: el.analysisType,
            text: this.$i18n.locale === 'br' ? el.analysisType : this.$i18n.locale === 'es' ? el.analysisTypeEs : el.analysisTypeEn,
          });
        });
      }
    },

    'dataCard.typeAnalysis': function watchSelectedAnalysis(value) {
      if (this.allAnalysesTypes) {
        for (let i = 0; i < this.allAnalysesTypes.length; i += 1) {
          // if (value === this.allAnalysesTypes[i].analysisType) {
          //   this.optionsReports = this.allAnalysesTypes[i].reports;
          // }
          if (this.$i18n.locale === 'br'){
            if (value === this.allAnalysesTypes[i].analysisType) {
            this.optionsReports = this.allAnalysesTypes[i].reports;
            }
          } else if (this.$i18n.locale === 'us'){
            if (value === this.allAnalysesTypes[i].analysisTypeEn) {
            this.optionsReports = this.allAnalysesTypes[i].reports;
            }
          } else if (this.$i18n.locale === 'es'){
            if (value === this.allAnalysesTypes[i].analysisTypeEs) {
            this.optionsReports = this.allAnalysesTypes[i].reports;
            }
          }
        }

         this.optionsReports.forEach((report) => {
          // remove reports
          if(report.text === 'Tags de tratativas' ||
            report.text === 'Monitoramento de pesquisa'){
           // report.text === 'Conversão'){
            const indexReport = this.optionsReports.findIndex(i => i.text === report.text);
            this.optionsReports.splice(indexReport, 1);
          }
        });

        const lang = this.$i18n.locale
        this.optionsReports = this.optionsReports.map(function returnNewArray(item){
            if(lang == "br"){
                const newArray = {
                  text: item.text,
                  value: item.text,
               }
              return newArray
            }

            if(lang == "us"){
                const newArray = {
                  text: item.textEn,
                  value: item.text,
                }
              return newArray
            }

            if(lang == "es"){
                const newArray = {
                  text: item.textEs,
                  value: item.text,
            }
              return newArray
            }

            return [];
        })

        this.optionsReports.sort((a,b)=> (a.text > b.text ? 1 : -1))
      }
    },

    // valueIndicator: async function watchValueIndicator(value) {
    //    this.dataCard.valueIndicator = value.text;
    // },

    indicator: async function watchValueIndicator(value) {
      const response = await api.get(
        `/filters/indicator-data/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            indicatorValue: value.key,
          },
        },
      );

      this.valuesIndicator = response.data;
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    await this.getTypeAnalysis();
    await this.handleIndicator();
    await this.returnTypeAnalysis(this.dataCard);

    if(this.dataCard.valueIndicator && this.dataCard.valueIndicator.includes(',')){
      this.splits = this.dataCard.valueIndicator.split(',');
      } else {
        this.arrayIndicators.push({
            key: this.dataCard.indicator,
            value: this.dataCard.valueIndicator
        })
    }

    if(this.splits.length > 0){
        for(let i=0; i < this.splits.length; i+=1){
          this.arrayIndicators.push({
            key: this.dataCard.indicator,
            value: this.splits[i]
          })
            this.blockLoop = true;
        }
    }

    this.allActionGroup = this.allGroups;
    // this.actions = this.allActions;
    // this.allActionData = this.allActions;
    this.allBranches = this.ih1.listFilters;

    this.optionsMetrics = [
      {
        value: null,
        text: `${this.$t('panel.createCardPanel.metrics.selectMetric')}`
      },
      {
        value: 'nps-0-10',
        text: `${this.$t('panel.createCardPanel.metrics.nps0to10')}`
      },
      {
        value: 'nps-1-5',
        text: `${this.$t('panel.createCardPanel.metrics.nps1to5')}`
      },
      {
        value: 'ces-1-5',
        text: `${this.$t('panel.createCardPanel.metrics.ces1to5')}`
      },
      {
        value: 'csat-1-5',
        text: `${this.$t('panel.createCardPanel.metrics.csat1To5')}`
      },
      {
        value: 'csat-1-5(media)',
        text: `${this.$t('panel.createCardPanel.metrics.csat1To5Media')}`
      },
      {
        value: '5-stars',
        text: `${this.$t('panel.createCardPanel.metrics.fiveStars')}`
      },
      {
        value: 'like-dislike',
        text: `${this.$t('panel.createCardPanel.metrics.likeDislike')}`
      },
    ];

    this.optionsGroup = [
      { value: null, text: `${this.$t('panel.createCardPanel.chooseFilterTitle')}`},
      { value: 'Grupo de ações', text: `${this.$t('panel.createCardPanel.chooseFilter.actionGroup')}`},
      { value: 'Ação', text: `${this.$t('panel.createCardPanel.chooseFilter.action')}`},
      { value: 'Indicador', text: `${this.$t('panel.createCardPanel.chooseFilter.indicator')}`},
      { value: 'Filial', text: `${this.$t('panel.createCardPanel.chooseFilter.filial')}`},
    ];

    this.optionsPeriod = [
      { value: null, text: `${this.$t('panel.createCardPanel.timeChoise')}`},
      { value: 'Hoje', text: `${this.$t('panel.createCardPanel.chooseTime.today')}`},
      { value: 'Ontem', text: `${this.$t('panel.createCardPanel.chooseTime.yesterday')}`},
      { value: 'Ultimos 30 dias', text: `${this.$t('panel.createCardPanel.chooseTime.last30Days')}`},
      { value: 'Mes atual', text: `${this.$t('panel.createCardPanel.chooseTime.currentMonth')}`},
      { value: 'Mes anterior', text: `${this.$t('panel.createCardPanel.chooseTime.lastMonth')}`},
      { value: 'Ano atual', text: `${this.$t('panel.createCardPanel.chooseTime.currentYear')}`},
      { value: 'Ano anterior', text: `${this.$t('panel.createCardPanel.chooseTime.lastYear')}`},
      { value: 'Personalizado', text: `${this.$t('panel.createCardPanel.chooseTime.customized')}`, disabled: true },
    ];

    await this.getProfiles({
      token: this.userAuth.token,
      companyId: this.userAuth.companyId,
    });
  },
};
</script>

<style scoped>
.tags-array {
  background: #4ce595;
  padding: 4px 8px;
  color: #fff;
  border-radius: 8px;
  margin-right: 8px;
  min-width: 30%;
  max-width: 80%;
  margin-top: 10px;
}

.string--formater-drop {
  display: block;
  font-size: 14px;
  width: 372px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.btn-loadmore {
  border: none;
  padding: 10px 20px;
  font-size: 18px;
  cursor: pointer;
  color: #4ce595;
  border-radius: 4px;
  background-color: #fff;
}

.button--formater2 {
  float: left;
}

.button--formater {
  float: left;
}

.tag {
  background: #4ce595;
  padding: 4px 8px;
  color: #fff;
  border-radius: 8px;
  margin-right: 8px;
  min-width: 30%;
  max-width: 80%;
  margin-top: 10px;
}

.remove {
  cursor: pointer;
}

.ball-one {
  border-radius: 50%;
  display: inline-table;
  height: 25px;
  color: #fff;
  width: 25px;
  font-size: 14px;
  border: 1px solid #3db374;
  background-color: #3db374;
}

.ball-two {
  border-radius: 50%;
  display: inline-table;
  height: 25px;
  color: #fff;
  width: 25px;
  font-size: 14px;
  border: 1px solid #bdbdbd;
  background-color: #bdbdbd;
}

.cards {
  align-items: center;
  justify-content: center;
  display: flex;
  padding-top: 25px;
}

.title-card {
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
}

.description {
  font-weight: 400;
  font-size: 12px;
  color: #242424;
}

#card-default {
  max-width: 80rem;
  width: 80rem;
  height: 30rem;
}

#card-custom {
  max-width: 80rem;
  width: 80rem;
  background-color: #f8f9fa;
  height: 30rem;
}

.card-img-top {
  padding-top: 40px;
  padding-right: 40px;
  padding-left: 40px;
}

.ball-create-panel {
  border-radius: 50%;
  display: inline-table;
  height: 25px;
  color: #fff;
  width: 25px;
  font-size: 14px;
  border: 1px solid #3db374;
  background-color: #3db374;
}

.text-create-panel {
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 5px;
  margin-top: 20px;
}

.b-sidebar-outer {
  z-index: 1040;
}

.create-card {
  font-weight: 700;
  font-size: 26px;
  line-height: 28px;
}

.card-description {
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
}

.main-sidebar {
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 12px;
  background: #fff;
}

.label-text {
  margin-bottom: 0;
  margin-top: 15px;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/edit-card/index.vue